import type { SYSAction } from "../../../../../../_ovlclient/src"
import { TableRefresh } from "../../../../../../_ovlclient/src/library/table/tableapi"

const HookScreenRefresh: SYSAction = async (_, { global }) => {
  await TableRefresh("SPCSymbolPCEndUser", {
    forcedFilters: { staticFilter: { U_CardCode: global.getState().ovl.user.cardCode } },
  })
}

const HookScreenNavigateIn = async (_, { global }) => {
  await TableRefresh("SPCSymbolPCEndUser", {
    forcedFilters: { staticFilter: { U_CardCode: global.getState().ovl.user.cardCode } },
  })
}

let hooks = { HookScreenNavigateIn, HookScreenRefresh }
export let SPCSymbolPCEndUser = { hooks }
